import * as React from 'react';
import DeliveryStatus from 'constants/DeliveryStatus';

type Props = {
  status: string;
};

export default function DeliveryStatusLabel(props: Props) {
  // Since this is used as a component we need to force it to return a react node
  return <>{humanReadableStatus(props.status)}</>;
}

export function humanReadableStatus(status: string): string | null {
  switch (status) {
    case DeliveryStatus.SENDING:
      return 'Sending';
    case DeliveryStatus.DELIVERY_ERROR:
      return 'Error';
    case DeliveryStatus.READ:
      return 'Read';
    case DeliveryStatus.SENT:
      return 'Sent';
    case DeliveryStatus.DELIVERED:
      return 'Delivered';
    default:
      return null;
  }
}
